import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

export function ModalFilter({
  onHide,
  show,
  CustomToggleList,
  columnToggleProps,
  modalIsHidden,
  setModalIsHidden,
  setToggleChecked,
  toggleChecked,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      autoFocus={false}
      enforceFocus={false}
      backdrop={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Table Filter Column</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CustomToggleList {...columnToggleProps} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
